import { withNamespace } from "@/i18n/lazy-route"

/** Top-ups (LLD §9.9, Tasks 4.2, 4.3), with the `topup` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/topup.json"),
  fr: () => import("@/i18n/locales/fr/topup.json"),
}

export const TopupScreen = withNamespace(
  "topup",
  () => import("./screens/TopupScreen"),
  translations,
)
export const TopupStatusScreen = withNamespace(
  "topup",
  () => import("./screens/TopupStatusScreen"),
  translations,
)
export const PayReturnScreen = withNamespace(
  "topup",
  () => import("./screens/PayReturnScreen"),
  translations,
)
